import {
    /** FETCH APPLICATION  */
    FETCH_ATTACHFILE_FULFILLED,
    FETCH_ATTACHFILE_REJECTED,
    FETCH_ATTACHFILE_PENDING,
    FETCH_ATTACHFILE_PROGRESS,
    RESET_ATTACHFILE
} from "../../actions/v3/attachFile";
const initialState = {
    done: false,
    error: false,
    spinner: false,
    uploadProgress: 0, // Bu alanı ekleyin
};
export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ATTACHFILE_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_ATTACHFILE_FULFILLED:
            return {
                ...state,
                attachFile: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_ATTACHFILE_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case FETCH_ATTACHFILE_PROGRESS:
            return {
                ...state,
                uploadProgress: action.payload,
                done: false,
                error: false,
                spinner: true,
            };
        case RESET_ATTACHFILE:
            return {
                initialState
            };
        default:
            return state;
    }
};